var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase, RestResult } from "@ane/core/lib/services/RestServiceBase";
import { onError } from "@ane/core/lib/decorators/OnError";
import { VNEXT_ANALYSIS_API_VERSION } from "./ExpAPIV2.constants.js";
import { parseError } from "@ane/core/lib/utils/ErrorUtils";
import ___default from "lodash";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let AnalysisResource = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.expanalysis, "/workspaces/", parseError);
  }
  getAnalyses(workspaceId, experimentStepId, top = 500, skip = 0) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/experimentsteps/${experimentStepId}/analyses?api-version=${VNEXT_ANALYSIS_API_VERSION}&$top=${top}&$skip=${skip}&$count=true`;
      const result = yield this._get(address);
      return result;
    });
  }
  getPreviewAnalyses(workspaceId, metricSetName, top = 20, skip = 0) {
    return __async(this, null, function* () {
      const metricSetVersionFilter = "analysisTemplate/metricSetVersion ne null";
      const orderByFilter = "changeLog/createdDateTime desc";
      const metricSetNameFilter = `analysisTemplate/metricSetName eq '${metricSetName}'`;
      const address = !!metricSetName ? `${workspaceId}/analyses?api-version=${VNEXT_ANALYSIS_API_VERSION}&$filter=${metricSetVersionFilter} and ${metricSetNameFilter}&$top=${top}&$skip=${skip}&$orderBy=${orderByFilter}&$count=false` : `${workspaceId}/analyses?api-version=${VNEXT_ANALYSIS_API_VERSION}&$filter=${metricSetVersionFilter}&$top=${top}&$skip=${skip}&$orderBy=${orderByFilter}&$count=false`;
      const result = yield this._get(address);
      return result;
    });
  }
  getAnalysis(workspaceId, analysisId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/analyses/${analysisId}?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      const [analysisResult, scorecardRequestsResult] = yield Promise.all([
        this._get(address),
        this.getScorecardRequests(workspaceId, analysisId)
      ]);
      if (analysisResult.statusCode === 301) {
        return analysisResult;
      }
      if (analysisResult.isSuccessful() && scorecardRequestsResult.isSuccessful()) {
        analysisResult.getSuccessData().value.scorecardRequests = scorecardRequestsResult.getSuccessData().value;
      }
      return analysisResult;
    });
  }
  getHypothesis(workspaceId, featureId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/features/${featureId}/hypothesis?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      const result = yield this._get(address);
      if (result.statusCode === 400 || result.statusCode === 404) {
        return RestResult.fromResult({ value: {} });
      }
      return result;
    });
  }
  createOrUpdateHypothesis(workspaceId, featureId, request) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/features/${featureId}/hypothesis?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      return yield this._put(request, address);
    });
  }
  createAnalysis(workspaceId, request) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/analyses?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      return yield this._post(request, address);
    });
  }
  updateAnalysis(workspaceId, analysisId, request) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/analyses/${analysisId}?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      return yield this._patch(request, address);
    });
  }
  deleteAnalysis(workspaceId, analysisId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/analyses/${analysisId}?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      return yield this._delete(address);
    });
  }
  resubmitScorecard(workspaceId, scorecardId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/scorecards/${scorecardId}/operations/resubmit?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      const result = yield this._post(null, address);
      result.ensureSuccess();
      return result;
    });
  }
  cancelScorecard(workspaceId, scorecardId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/scorecards/${scorecardId}/operations/cancel?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      const result = yield this._post(null, address);
      result.ensureSuccess();
      return result;
    });
  }
  uploadSupportFiles(workspaceId, experimentStepId, fileInfos) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/experimentsteps/${experimentStepId}/supportfiles?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      let formData = new FormData();
      ___default.each(fileInfos, (f) => formData.append(f.name, f.data));
      const result = yield this._postFormData(address, formData);
      return result;
    });
  }
  registerAnalysis(workspaceId, experimentStepId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/experimentsteps/${experimentStepId}/registeranalyses?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      const result = yield this._put(null, address);
      return result;
    });
  }
  getScorecardRequests(workspaceId, analysisId, top = 400, skip = 0) {
    return __async(this, null, function* () {
      let address = `${workspaceId}/analyses/${analysisId}/scorecards?api-version=${VNEXT_ANALYSIS_API_VERSION}&$top=${top}&$skip=${skip}`;
      address += EnvironmentService.showDetailedTaskState() ? "&$detailedState=true" : "";
      const result = yield this._get(address);
      return result;
    });
  }
  getScorecardRequest(workspaceId, scorecardId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/scorecards/${scorecardId}/request?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      return yield this._get(address);
    });
  }
  getAnalysisGroup(workspaceId, experimentStepId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/experiment-steps/${experimentStepId}/analysis-groups?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      return yield this._get(address);
    });
  }
  deleteAnalysisGroup(workspaceId, analysisGroupId, analysisTemplateNames) {
    return __async(this, null, function* () {
      let analysisTemplateNamesQuery = "";
      ___default.forEach(analysisTemplateNames, (templateName) => analysisTemplateNamesQuery += `&analysisTemplateNames=${templateName}`);
      const address = `${workspaceId}/analysis-groups/${analysisGroupId}?api-version=${VNEXT_ANALYSIS_API_VERSION}${analysisTemplateNamesQuery}`;
      return yield this._delete(address);
    });
  }
  getFeatureAutoTriggeringState(workspaceId, featureId) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/features/${featureId}/featureFlagTriggering?api-version=${VNEXT_ANALYSIS_API_VERSION}`;
      return yield this._get(address);
    });
  }
  setFeatureAutoTriggeringState(workspaceId, featureId, autoTriggerState) {
    return __async(this, null, function* () {
      const address = `${workspaceId}/features/${featureId}/featureFlagTriggering?api-version=${VNEXT_ANALYSIS_API_VERSION}&value=${autoTriggerState}`;
      return yield this._put(null, address);
    });
  }
};
__decorateClass([
  onError({ message: `An error occured while getting analyses.` })
], AnalysisResource.prototype, "getAnalyses", 1);
__decorateClass([
  onError({ message: `An error occured while getting analyses.` })
], AnalysisResource.prototype, "getPreviewAnalyses", 1);
__decorateClass([
  onError({ message: `An error occured while getting analysis.` })
], AnalysisResource.prototype, "getAnalysis", 1);
__decorateClass([
  onError({ message: `An error occured while creating an analysis.` })
], AnalysisResource.prototype, "createAnalysis", 1);
__decorateClass([
  onError({ message: `An error occured while updating an analysis.` })
], AnalysisResource.prototype, "updateAnalysis", 1);
__decorateClass([
  onError({ message: `An error occured while deleting an analysis.` })
], AnalysisResource.prototype, "deleteAnalysis", 1);
__decorateClass([
  onError({ message: `An error occured while resubmitting a scorecard.` })
], AnalysisResource.prototype, "resubmitScorecard", 1);
__decorateClass([
  onError({ message: `An error occured while cancelling a scorecard.` })
], AnalysisResource.prototype, "cancelScorecard", 1);
__decorateClass([
  onError({ message: `An error occurred while uploading files` })
], AnalysisResource.prototype, "uploadSupportFiles", 1);
__decorateClass([
  onError({ message: `An error occurred while registering analysis.` })
], AnalysisResource.prototype, "registerAnalysis", 1);
__decorateClass([
  onError({ message: `An error occured while getting scorecard requests for an analysis.` })
], AnalysisResource.prototype, "getScorecardRequests", 1);
__decorateClass([
  onError({ message: `An error occured while getting a scorecard request.` })
], AnalysisResource.prototype, "getScorecardRequest", 1);
AnalysisResource = __decorateClass([
  WPSProxyConverter()
], AnalysisResource);
const Analysis_resource = new AnalysisResource();
export {
  AnalysisResource,
  Analysis_resource as default
};
//# sourceMappingURL=Analysis.resource.js.map
